<template>
  <div class="cf-control">
    <div v-if="type === 'status_ryg'" class="flex gap-2">
      <span class="cf-chip bg-red-100 text-red-700">Red</span>
      <span class="cf-chip bg-amber-100 text-amber-700">Yellow</span>
      <span class="cf-chip bg-green-100 text-green-700">Green</span>
    </div>

    <div v-else-if="type === 'yes_no_na'" class="flex gap-2">
      <span class="cf-chip bg-gray-100 text-gray-700">Yes</span>
      <span class="cf-chip bg-gray-100 text-gray-700">No</span>
      <span class="cf-chip bg-gray-100 text-gray-700">N/A</span>
    </div>

    <div
      v-else-if="type === 'single_select'"
      class="flex w-64 items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-500"
    >
      <span>{{ previewOptions[0] }}</span>
      <i class="fas fa-chevron-down text-xs text-gray-400"></i>
    </div>

    <div v-else-if="type === 'multi_select'" class="space-y-1">
      <span
        v-for="(opt, i) in previewOptions"
        :key="i"
        class="flex items-center gap-2 text-sm text-gray-600"
      >
        <span class="h-4 w-4 rounded border border-gray-300 bg-white"></span>
        {{ opt }}
      </span>
    </div>

    <div v-else-if="type === 'number'" class="flex items-center gap-2">
      <span
        class="w-24 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-400"
        >0</span
      >
      <span class="text-sm text-gray-500">{{ unit || "unit" }}</span>
    </div>

    <div
      v-else-if="type === 'text'"
      class="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-400"
    >
      Free text…
    </div>

    <div
      v-else-if="type === 'date'"
      class="flex w-44 items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-400"
    >
      <span>mm / dd / yyyy</span>
      <i class="fas fa-calendar-days text-gray-400"></i>
    </div>

    <span
      v-else-if="type === 'checkbox'"
      class="flex items-center gap-2 text-sm text-gray-600"
    >
      <span class="h-4 w-4 rounded border border-gray-300 bg-white"></span>
      Done
    </span>

    <div v-else-if="type === 'star_rating'" class="flex gap-1 text-lg">
      <i v-for="n in 5" :key="n" class="fas fa-star text-gray-300"></i>
    </div>

    <div
      v-else-if="type === 'signature'"
      class="flex h-14 items-end rounded-md border border-dashed border-gray-300 bg-white px-3 pb-1 text-xs italic text-gray-400"
    >
      Sign here
    </div>

    <div
      v-else-if="type === 'photo_only'"
      class="flex w-44 items-center gap-2 rounded-md border border-dashed border-gray-300 bg-white px-3 py-2 text-sm text-gray-400"
    >
      <i class="fas fa-camera text-gray-400"></i>
      Add photos
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { QuestionOption } from "./customFormFields";

const props = withDefaults(
  defineProps<{
    type: string;
    options?: QuestionOption[];
    unit?: string | null;
  }>(),
  { options: () => [], unit: "" }
);

// Use the real option labels once entered; otherwise show placeholders so the
// control still reads as intended before anything is filled in.
const previewOptions = computed(() => {
  const labels = props.options.map((o) => o.label).filter(Boolean);
  return labels.length ? labels : ["Option 1", "Option 2"];
});
</script>

<style scoped>
.cf-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.125rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 500;
}
</style>
